import React from 'react';
import { Provider } from 'react-redux';
import '@britishcouncil/semantic-ui-admin/dist/semantic.min.css';
import { AppSettingsProvider } from '@britishcouncil/react-common';
import { OidcClient, OidcProvider, RequireAuth } from '@britishcouncil/react-oidc-auth';

import { Interceptors } from './Interceptors';
import { store } from 'store';
import { AppSettingsContext, DEFAULT_APP_SETTINGS } from 'settings';
import { FullScreenLoader } from 'components';
import { PermissionsProvider } from 'core';

export const Providers = ({ children }: { children: React.ReactNode }) => (
  <Provider store={store}>
    <AppSettingsProvider
      defaultAppSettings={DEFAULT_APP_SETTINGS}
      Context={AppSettingsContext}
      appSettingsSource="/appsettings.json"
      loader={<FullScreenLoader text="One second, please..." />}
      error={<FullScreenLoader text="Something went wrong, try refreshing the app." />}
    >
      <AppSettingsContext.Consumer>
        {({ userManagerSettings }) => (
          <OidcProvider
            {...userManagerSettings}
            userStore={new OidcClient.WebStorageStateStore({ store: window.localStorage })}
          >
            <Interceptors>
              <RequireAuth loader={FullScreenLoader}>
                <PermissionsProvider>{children}</PermissionsProvider>
              </RequireAuth>
            </Interceptors>
          </OidcProvider>
        )}
      </AppSettingsContext.Consumer>
    </AppSettingsProvider>
  </Provider>
);
